import React from 'react'
import PropTypes from 'prop-types'
import { compose, pure } from 'recompose'

import EditProblemItem from '../EditProblemItem/EditProblemItem'
import Button from '../../atoms/Button/Button'
import './EditProblem.css'

export const Type = {
  DROPDOWN: 'dropDown',
  TEXTFIELD: 'textField',
  TEXTAREA: 'textArea'
}

const EditProblem = ({ problemSet, handleDeleteQuestion, isHiddenDeleteButton }) => {
  let problems = []
  const titles = ['問題文', '制限時間']
  for (let i in problemSet) {
    const ps = problemSet[i]
    const title = titles[i]
    problems.push(
      <EditProblemItem
        idx={i}
        key={i}
        itemType={ps.type}
        problemTitle={title}
        contents={ps.content}
        onChangeProblemContent={ps.changeProblem}
        selectedValue={ps.selectedValue}
      />
    )
  }
  return (
    <div styleName="container">
      {problems}
      <div styleName="only-sp">
        {isHiddenDeleteButton ? null : (
          <Button handleClick={handleDeleteQuestion}>
            <p styleName="button-text">問題を削除</p>
          </Button>
        )}
      </div>
    </div>
  )
}

EditProblem.propTypes = {
  problemSet: PropTypes.array,
  handleDeleteQuestion: PropTypes.func,
  isHiddenDeleteButton: PropTypes.bool.isRequired
}

EditProblem.defaultProps = {
  isHiddenDeleteButton: false
}

export default compose(pure)(EditProblem)
